import { render } from "./CustomLoader.vue?vue&type=template&id=57a35f91&scoped=true"
import script from "./CustomLoader.vue?vue&type=script&lang=js"
export * from "./CustomLoader.vue?vue&type=script&lang=js"

import "./CustomLoader.vue?vue&type=style&index=0&id=57a35f91&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57a35f91"

export default script